export default __webpack_public_path__ + "c31a752c70548b788e1c933f6d3c388f.svg";